import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'
import SelectComponent from '../Select/Select'
import { MainContainer } from '../../theme/mainContainer.styled'
import Search from '../../images/icons/search-black.svg'
import Autocompletion from '../Autocompletion/Autocompletion'
import ProductSelect from '../ProductSelect/ProductSelect'

export const StyledSearchBar = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;
  padding-bottom: ${({ isOurProducts }) => (isOurProducts ? pxToRem(20) : 0)};
  background-color: ${({ isOurProducts, theme }) =>
    isOurProducts ? theme.colors.unique.black : theme.colors.unique.white};
`

export const StyledMainContainer = styled(MainContainer)`
  padding: ${pxToRem(20)} ${pxToRem(10)};
`

export const StyledSearchForm = styled.form`
  position: relative;
  align-items: center;
  display: flex;
  width: 100%;
  @media ${deviceMax.mobileL} {
    height: 100%;
    flex-direction: column;
  }
`

export const StyledSearchTop = styled.div`
  align-items: center;
  flex: 1;
  display: flex;
  @media ${deviceMax.mobileL} {
    flex-direction: column;
    width: 100%;
  }
`

export const StyledSearchBottom = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
  @media ${deviceMax.mobileL} {
    width: 100%;
  }
`

export const StyledInput = styled.input`
  border: initial;
  border-radius: ${pxToRem(5)};
  width: 100%;
  height: ${pxToRem(40)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  background-color: ${({ isOurProducts, theme }) =>
    isOurProducts ? theme.colors.unique.white : theme.colors.secondary.grey95};
  @media ${deviceMax.mobileL} {
    margin-left: ${pxToRem(10)};
  }
`

export const StyledSearchButton = styled(Button)`
  justify-content: center;
  display: flex;
  height: ${pxToRem(40)};
  @media ${deviceMax.mobileL} {
    margin-left: initial;
    width: 100%;
    height: ${pxToRem(40)};
  }
`

export const SearchIcon = styled(Search)`
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
`

export const StyledInputContainer = styled.div`
  z-index: 6;
  position: relative;
  flex: 1;
  align-items: center;
  display: flex;
  margin-right: ${({ isOurProducts }) =>
    isOurProducts ? pxToRem(40) : pxToRem(20)};
  border-radius: ${({ inputFocused }) =>
    inputFocused ? `${pxToRem(5)} ${pxToRem(5)} 0 0` : pxToRem(5)};
  height: 100%;
  padding: 0 ${pxToRem(10)};
  background-color: ${({ isOurProducts, theme }) =>
    isOurProducts ? theme.colors.unique.white : theme.colors.secondary.grey95};
  @media ${deviceMax.mobileL} {
    padding: 0 ${pxToRem(5)} 0 0;
    margin-right: 0;
    margin-bottom: ${pxToRem(20)};
    width: 100%;
  }
`

export const StyledSelect = styled(SelectComponent)`
  z-index: 5;
  flex: 1;
  margin-right: ${({ isOurProducts }) =>
    isOurProducts ? pxToRem(40) : pxToRem(20)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  .react-select__control {
    background-color: ${({ isOurProducts, theme }) =>
      isOurProducts
        ? theme.colors.unique.white
        : theme.colors.secondary.grey95};
  }
  @media ${deviceMax.mobileL} {
    margin-right: initial;
    margin-bottom: ${pxToRem(20)};
    width: 100%;
  }
`

export const StyledParagraph = styled.p`
  margin-top: ${pxToRem(40)};
  max-width: ${pxToRem(798)};
  padding: 0 ${pxToRem(10)} ${pxToRem(20)} ${pxToRem(10)};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  text-align: center;
  color: ${({ theme }) => theme.colors.unique.white};
`

export const StyledAutocompletion = styled(Autocompletion)`
  top: ${pxToRem(40)};
`

export const StyledProductSelect = styled(ProductSelect)`
  flex: 1;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
`
